export default "__VITE_ASSET__CyWSkTlB__"